export const isFalsy = (value: unknown) => (value === 0 ? false : !value);

export const isVoid = (value: unknown) => value === null || value === undefined || value === '';

// 類型為鍵值對
export const cleanObject = (object: any = {}) => {
	// 等同於Object.assign({}, object)
	const result = { ...object };
	Object.keys(result).forEach((key) => {
		const value = result[key];
		if (isVoid(value)) {
			delete result[key];
		}
	});
	return result;
};
